import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_false, assert_not_equal, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { TYPE__class_constructor } from '@shared/types/TYPE__class_constructor';
import { ENUM__dto_class_name } from '../ENUM__dto_class_name';
import { FN_SERIALIZATION__check_stub } from './FN_SERIALIZATION__check_stub';
export function FN_SERIALIZATION__register_class<T>(class_name: string, class_object: TYPE__class_constructor<T>) {
  assert_not_equal(class_name, ENUM__dto_class_name.ABSTRACT);
  assert_false(class_name in CONSTANTS__shared.CLASS_MAPPING_REGISTERED_CLASSES, { assert_type: ENUM__error_type.VALIDATION_ITEM_ALREADY_EXISTS, class_name });
  assert_string_not_empty(class_name);

  CONSTANTS__shared.CLASS_MAPPING_REGISTERED_CLASSES[class_name] = class_object;

  FN_SERIALIZATION__check_stub(class_name, class_object);
}
